export const downgradeToken = "85dbb5824b0551ad037dd938d846f649";



// WEBPACK FOOTER //
// ./src/const/payment.js